
import Vue from 'vue'
import { VDialog } from 'vuetify/lib'
import JcdcModalCard from '@/components/jcdc/JcdcModalCard.vue'

export default Vue.extend({
  name: 'JcdcModal',
  components: {
    VDialog,
    JcdcModalCard,
  },
  props: {
    title: {
      type: String,
      default: undefined,
    },
    primaryBtn: {
      type: String,
      default: 'OK',
    },
    secondaryBtn: {
      type: String,
      default: 'Cancel',
    },
    color: {
      type: String,
      default: 'primary',
    },
    hideDefaultActions: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'standard',
    },
    required: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: this.open,
    }
  },
  computed: {
    sizeCalc() {
      if (this.size === 'small') return '300px'
      else if (this.size === 'large') return '800px'
      else if (this.size === 'x-large') return '1140px'
      return '500px'
    },
  },
  watch: {
    open() {
      this.dialog = this.open
    },
    dialog() {
      this.$emit('input', this.dialog)
    },
  },
  methods: {
    primaryBtnClick() {
      this.dialog = false
      this.$emit('primary-click')
    },
    secondaryBtnClick() {
      this.dialog = false
      this.$emit('secondary-click')
    },
  },
})
